/* eslint-disable camelcase */
import React from 'react';
import { dateFormat } from 'enums';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var accountReferenceColumns = [{
  name: 'Падеж на вноската',
  value: 'due_date',
  dateTimeFormat: dateFormat,
  width: '120px'
}, {
  name: '№ договор',
  value: 'number',
  width: '110px'
}, {
  name: 'Кредитополучател',
  value: 'borrower_name'
}, {
  name: 'Вноска по кред.',
  render: function render(_ref) {
    var total_due_amount = _ref.total_due_amount,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_due_amount"
    }, total_due_amount, " ", currency);
  }
}, {
  name: 'Главница',
  render: function render(_ref2) {
    var principal = _ref2.principal,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "principal"
    }, principal, " ", currency);
  },
  invisibleBelow: 1800
}, {
  name: 'Лихва',
  render: function render(_ref3) {
    var interest = _ref3.interest,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "interest"
    }, interest, " ", currency);
  },
  invisibleBelow: 1800
}, {
  name: 'Наказ. лихви',
  render: function render(_ref4) {
    var penalty = _ref4.penalty,
        currency = _ref4.currency;
    return ___EmotionJSX("span", {
      "data-value": "penalty"
    }, penalty, " ", currency);
  },
  invisibleBelow: 1800
}, {
  name: 'Общо лихви',
  render: function render(_ref5) {
    var total_interest = _ref5.total_interest,
        currency = _ref5.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_interest"
    }, total_interest, " ", currency);
  },
  invisibleBelow: 1800
}, {
  name: 'Мес. вноска дог. посещение',
  render: function render(_ref6) {
    var home_visit_fee = _ref6.home_visit_fee,
        currency = _ref6.currency;
    return ___EmotionJSX("span", {
      "data-value": "home_visit_fee"
    }, home_visit_fee, " ", currency);
  },
  invisibleBelow: 1800
}, {
  name: 'Платена сума',
  render: function render(_ref7) {
    var payment_amount = _ref7.payment_amount,
        currency = _ref7.currency;
    return ___EmotionJSX("span", {
      "data-value": "payment_amount"
    }, payment_amount, " ", currency);
  }
}, {
  name: 'Сключен на дата',
  value: 'contract_date',
  dateTimeFormat: dateFormat
}, {
  name: 'Платена на дата',
  value: 'payment_date',
  dateTimeFormat: dateFormat
}];